import React from "react";
import CV from "../../assets/CV - Assis Junior.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} className="btn" download>
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Contactar
      </a>
    </div>
  );
};

export default CTA;
